export default __webpack_public_path__ + "static/media/Exec.8b62e4ee.svg";